import React, { FC, Fragment, useEffect, useState } from 'react';
import { PickUpDetails, Transfer } from 'ts/transfer/interfaces/TransferResultsResponse';
import { useTranslation } from 'react-i18next';
import { Position } from 'ts/transfer/interfaces/Transfer';
import TransferResultGoogleMap from './ResultGoogleMap';
import TransferResultOSMMap from './ResultOSM';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { mapSupplier } from 'constants/generic';

interface TransferResultMapProps {
  mapTransfer: Transfer;
}

interface MapData {
  pickup: Position;
  dropoff: Position;
}

const TransferResultMap: FC<TransferResultMapProps> = (props) => {
  const [t] = useTranslation();
  const [distance, setDistance] = useState('');
  const [mapData, setMapData] = useState<MapData>();
  const [center, setCenter] = useState<Position>();

  const getLocalName = (item: PickUpDetails) => {
    if (item.airport) {
      return item.airport.desc;
    } else if (item.city) {
      return item.city.desc;
    }
    return '';
  };

  useEffect(() => {
    const { pickUpDetails, dropOffDetails } = props.mapTransfer;
    const pickup = pickUpDetails?.airport?.geoCodes
      ? {
          lat: +pickUpDetails.airport.geoCodes.latitude,
          lng: +pickUpDetails.airport.geoCodes.longitude,
        }
      : {
          lat: +pickUpDetails?.city?.geoCodes?.latitude,
          lng: +pickUpDetails?.city?.geoCodes?.longitude,
        };

    const dropoff = dropOffDetails?.airport?.geoCodes
      ? {
          lat: +dropOffDetails.airport.geoCodes.latitude,
          lng: +dropOffDetails.airport.geoCodes.longitude,
        }
      : {
          lat: +dropOffDetails?.city?.geoCodes?.latitude,
          lng: +dropOffDetails?.city?.geoCodes?.longitude,
        };

    const newCenter = {
      lat: (pickup.lat + dropoff.lat) / 2,
      lng: (pickup.lng + dropoff.lng) / 2,
    };

    setMapData({ pickup, dropoff });
    setCenter(newCenter);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="default-shadow transfer-sum">
      <div className="title-underline text-lg title-header-grey">
        {t('transfer.distance')} {distance ? `(${distance})` : ''}
      </div>
      <div className="h200px w100p">
        {mapData && center && (
          <Fragment>
            {mapSupplier === 'google' && (
              <TransferResultGoogleMap
                transfer={props.mapTransfer}
                center={center}
                mapData={mapData}
                getLocalName={getLocalName}
                onChangeDirection={setDistance}
              />
            )}
            {mapSupplier === 'osm' && (
              <TransferResultOSMMap
                transfer={props.mapTransfer}
                center={center}
                mapData={mapData}
                getLocalName={getLocalName}
                onChangeDirection={setDistance}
              />
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(TransferResultMap, 'TransferResultMap');
